import { useEffect } from "react"

import { Flex, Form, Input, Modal } from "antd"
import { useTranslation } from "react-i18next"

import Button from "../../../Components/Button"

const { TextArea } = Input

const AddCommentModal = ({ open, initialValue, submitting, onSubmit, onCancel }) => {
  const { t } = useTranslation()
  const [form] = Form.useForm()

  useEffect(() => {
    if (!open) return
    form.resetFields()
    form.setFieldsValue({ comment_text: initialValue || "" })
  }, [open, initialValue, form])

  const handleFinish = ({ comment_text }) => {
    onSubmit(comment_text?.trim() || "")
  }

  return (
    <Modal
      open={open}
      title={initialValue ? t("Edit comments") : t("Add comments")}
      onCancel={onCancel}
      footer={null}
      width={442}
      destroyOnClose
      data-testid="comment-modal"
    >
      <Form form={form} layout="vertical" onFinish={handleFinish}>
        <Form.Item
          name="comment_text"
          rules={
            initialValue
              ? []
              : [
                  {
                    required: true,
                    whitespace: true,
                    message: t("This field is required")
                  }
                ]
          }
        >
          <TextArea
            rows={4}
            placeholder={t(
              "Enter any additional or related information to this perk and/or benefit…"
            )}
            data-testid="comment-modal-text-input"
          />
        </Form.Item>
        <Flex justify="flex-end" gap={8}>
          <Button onClick={onCancel} disabled={submitting} data-testid="comment-modal-cancel-btn">
            {t("Cancel")}
          </Button>
          <Button
            type="primary"
            htmlType="submit"
            loading={submitting}
            data-testid="comment-modal-submit-btn"
          >
            {t("Submit")}
          </Button>
        </Flex>
      </Form>
    </Modal>
  )
}

export default AddCommentModal
